var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"svgicon",class:[_vm.className, (_vm.type === 'full') ? 'svgicon--full' : false],attrs:{"version":"1.1"}},[_c('use',{attrs:{"xlink:href":("#" + _vm.name)}})])}
var staticRenderFns = []

export { render, staticRenderFns }